import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'This formal yet still contemporary garden was designed for a large family with outdoor entertaining in mind. Its design features simple bold lines and spaces combined with the use of classical elements - an elegant pergola poolside and a striking spill over bowl as water feature and central focal point. At one end of the pool a cabana allows year round family gatherings whilst at the other end a generous built in bench matches the contemporary style and colourings.',
            'A simple elegant planting palette has been used of layered hedges, flowering trees and accents of purple. Subtle outdoor lighting further highlights the gardens features and allows extended use into the night.',
        ],
        descriptionContent : (
          <p>
          <span className="line">
          <b>Services Undertaken</b>
          <br />Landscape Architecture
          <br />Construction
          <br />Ongoing Maintenance
          <br />Application to Council
          <br />Structural Engineering
          </span>
          
          <b>Design Features</b>
          <br />Family
          <br />Entertainer
          <br />Classic
          <br />Pool
          </p>
          
        ),
        image : '../images/projects/strathfield-1.jpg',
        title : 'Strathfield'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/strathfield-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/strathfield-2.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/strathfield-3.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/strathfield-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/strathfield-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/strathfield-6.jpg'
    },
]

const PageStrathField = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageStrathField